// extracted by mini-css-extract-plugin
module.exports = {"section":"AdditionalResources_section__3-FpB"};